import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Chip } from '@frontend/design-system';

export const FallbackChip = () => {
  const { t } = useTranslation('calls');
  return <Chip variant='neutral'>{t('Fallback')}</Chip>;
};

export const DialOptionBadge = ({ displayValue }: { displayValue: string }) => {
  return (
    <div
      css={css`
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: ${theme.spacing(2.5)};
        height: ${theme.spacing(2.5)};
        border-radius: ${theme.borderRadius.full};
        font-size: ${theme.fontSize(12)};
        font-weight: ${theme.font.weight.bold};
        background-color: ${theme.colors.neutral50};
        color: ${theme.colors.white};
        user-select: none;
      `}
    >
      {displayValue}
    </div>
  );
};
